import { Component } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { UserService } from '../../services/user.service';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';

@Component({
    selector: 'account-view-modal',
    templateUrl: 'account-view-modal.html',
    styleUrls: ['./customer-creation.component.css'],
    standalone: false
})
export class AccountViewComponent {
  exchangeAccountList: any = [];
  cashAccountList: any = [];
  securityAccountList: any = [];
  loading: boolean = false;
  customerNo: any;
  isTableEmpty: boolean = true;
  customerDetails: any = {};
  loadingCustomerProfile: boolean = false;
  constructor(
    private modalService: MdbModalService,
    private userService: UserService,
    public modalRef: MdbModalRef<AccountViewComponent>
  ) {}
  ngOnInit(): void {
    this.getCustomerDetails(this.customerNo);
  }

  getCustomerDetails(customerNo: any) {
    this.loading = true;

    this.userService.getCustomerDetails(customerNo, 'asia').subscribe((data1: any) => {
      this.loading = false;
      if (data1.status == 'SUCCESS') {
        if (data1.cashAccounts.length) {
          this.isTableEmpty = false;

        } else {
          this.isTableEmpty = true;

        }


        this.customerDetails = data1;

      } else {
        this.isTableEmpty = true;
      }
    });
  }
}
